import { mapValues, assign, values, isEmpty } from 'lodash';
import MobxReactForm from 'mobx-react-form';
import * as validatorjs from 'validatorjs';

export interface FormModelProps {

  fields: object | string[];
  values?: object;
  initials?: object;
  defaults?: object;  
  labels?: object;
  placeholders?: object;
  rules?: object;
  bindings?: object;
  types?: object;
  extra?: object;

}

export class FormModel extends MobxReactForm {
  // tslint:disable-next-line:no-any
  $: (field: string) => any;

  // tslint:disable-next-line:no-any
  fields: any;
  invalidate: (message: string) => void;

  // tslint:disable-next-line:no-any
  onSubmit: any;
  error: string;

  has: (field: string) => boolean;

  hasErrors: boolean;

  isValid: boolean;

  isPristine: boolean;

  validate: (options: { showErrors: boolean }) => Promise<{ isValid: boolean }>;
  validating: boolean;

    // tslint:disable-next-line:no-any
  onDel: (e: any) => void;

  // tslint:disable-next-line:no-any
  del: (f: any) => void;

  // tslint:disable-next-line:no-any
  values: any;

  clear: () => void;

  constructor(
    options: FormModelProps) {
    super({ ...options },
      { plugins: { dvr: validatorjs } });
  }

  formValues() {
    const result = this.sanitizeValues(assign({},
      ...this.fields.values().map(field => {
        if (field.extra &&
          field.extra.service) {
          // NOTE: this is a hack for converting back dynamic fields from Form
          return {
            [field.name]: isEmpty(field.value) ? field.value : values(field.value)
          };
        } else {
          return {
            [field.name]: field.value
          };
        }
      })));
    return result;
  }

  // tslint:disable-next-line:no-any
  private sanitizeValues(formData: any, fieldPrefix: string = '') {
    return mapValues(formData, (value, name) => {
      const fieldName = `${fieldPrefix}${name}`;
      if (this.$(fieldName).type === undefined) {
        throw new Error(`field [${fieldName}] does not have a type`);
      }
      if (this.$(fieldName).type === 'date') {
        return new Date(value);
      }
      if (this.$(fieldName).type === 'number') {
        return parseInt(value, 10);
      }
      if (this.$(fieldName).type === 'object') {
        return this.sanitizeValues(value, `${fieldName}.`);
      }
      if (this.$(fieldName).type === 'boolean') {
        if (typeof (value) === 'boolean') {
          return value;
        }
        return value === '' ? false : value === 'true' ? true : false;
      }
      return value;
    });
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/form/Model.ts